var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanttChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M24,22.5c0,.83-.67,1.5-1.5,1.5H5.5c-3.03,0-5.5-2.47-5.5-5.5V1.5C0,.67,.67,0,1.5,0s1.5,.67,1.5,1.5V18.5c0,1.38,1.12,2.5,2.5,2.5H22.5c.83,0,1.5,.67,1.5,1.5Zm-8-6c0,.83,.67,1.5,1.5,1.5h5c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5h-5c-.83,0-1.5,.67-1.5,1.5Zm-7-6c0,.83,.67,1.5,1.5,1.5h8c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5H10.5c-.83,0-1.5,.67-1.5,1.5Zm-2.5-4.5h5c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5H6.5c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttChart);
export default __webpack_public_path__ + "static/media/ganttChart.d71715acf1b6b67cefc2145454324286.svg";
export { ForwardRef as ReactComponent };